export function extractDocName(url) {
    return url?.split('/')?.pop()?.split('?')?.shift();
}

export function shortenDocumentTitle(text) {
    const ext = text?.split('.')?.pop();

    if (text?.length > 50) {
        return `${text?.substring(0, 47)}...${ext}`;
    }

    return text;
}

/**
 * Function to resize an image from a URL to a base64 string with fixed height and dynamic width.
 * @param {string} url - The URL of the image to be resized.
 * @param {number} height - The desired fixed height of the resized image.
 * @returns {Promise<string>} - A promise that resolves to the base64 string of the resized image.
 */
export async function resizeURLImageToBase64(url, height) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'Anonymous';
        img.src = url;

        img.onload = () => {
            const originalWidth = img.naturalWidth;
            const originalHeight = img.naturalHeight;
            // Calculate scale to match the desired height
            const scale = height / originalHeight;
            const drawWidth = originalWidth * scale;

            // Create canvas with dynamic width and fixed height
            const canvas = document.createElement('canvas');
            canvas.width = drawWidth;
            canvas.height = height;
            const ctx = canvas.getContext('2d');

            // Draw scaled image filling the canvas width
            ctx.drawImage(img, 0, 0, originalWidth, originalHeight, 0, 0, drawWidth, height);

            // Return base64 string
            resolve(canvas.toDataURL('image/png'));
        };

        img.onerror = (error) => {
            reject(new Error(`Failed to load image: ${error.message}`));
        };
    });
}
